<template>
  <div class="border p-4 p-md-3 p-lg-4 rounded mb-4 Catalog__filters">
    <div class="mb-4" v-if="filtersSaved.length !== 0">
      <h3 class="mb-3 h6 text-uppercase text-black d-block">
        Moje hledání:
      </h3>
      <ul class="list-unstyled">
        <li v-for="filter in filtersSaved" :key="filter.id">
          {{ filter.name }}:
          <a v-if="canFeatureFilters" :href="`/katalog?${filter.data}`">Použít</a>
          <a v-else href="#" @click.prevent>Použít</a>
        </li>
      </ul>
    </div>
    <div class="mb-4">
      <div
        class="fb-share-button"
        :data-href="currentLocation"
        data-layout="button"
        data-size="large"
      ></div>

      <hr />

      <h3 class="mb-3 h6 text-uppercase text-black d-block">
        Cena
      </h3>
      <div id="slider-range" class="border-primary"></div>
      <input
        type="text"
        name="text"
        id="amount"
        class="form-control border-0 pl-0 bg-white"
        disabled=""
      />
    </div>

    <div class="mb-2" v-for="label in labels">
      <a
        href="#"
        class="label-title"
        :class="{ active: visible[label.id] || anyCheckedValues(label) }"
        @click.prevent="$set(visible, label.id, !visible[label.id])"
      >
        <span class="d-block">
          {{ label.name }}
        </span>
      </a>
      <div v-show="visible[label.id] || anyCheckedValues(label)" class="Catalog__filters-items">
        <label
          v-for="value in label.values"
          :key="value.id"
          :for="`label-value-${value.id}`"
          :class="[
            'd-flex label-value',
            {
              hide: !isChecked(value.id) && !visible[label.id],
              active: isChecked(value.id)
            }
          ]"
        >
          <input
            type="checkbox"
            :id="`label-value-${value.id}`"
            class="mr-2"
            @change="onFilter($event, value)"
            :checked="isChecked(value.id)"
          />
          <span class="text-black">{{ value.value }}</span>
        </label>
      </div>

      <a
        v-if="!visible[label.id] && anyCheckedValues(label)"
        href="#"
        class="label-more"
        @click.prevent="$set(visible, label.id, true)"
      >
        <p>Více</p>
      </a>
    </div>

    <hr />

    <button class="btn btn-primary w-100 mt-2" onclick="window.location.reload(true);">
      Použít
    </button>

    <a v-if="user && canFeatureFilters" class="btn btn-outline-secondary w-100 mt-2" :href="filtersCreateRedirect">
      Uložit filtr
    </a>
    <button
      v-if="!user"
      class="btn btn-outline-secondary w-100 mt-2"
      @click="requiresAuth(true, filtersCreateRedirect)"
    >
      Uložit filtr
    </button>

    <a class="btn btn-outline-secondary w-100 mt-2 border-0" href="/katalog">
      Vymazat vše
    </a>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    labels: {
      type: Array,
      required: true
    },
    filtersSaved: {
      type: Array,
      required: true
    },
    canFeatureFilters: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      visible: {},
      filters: [],
      price: [],
      queryString: ''
    }
  },
  computed: {
    filtersCreateRedirect() {
      return `/filters/create?filter=${encodeURIComponent(this.queryString)}`
    },
    currentLocation() {
      return location.href
    }
  },
  mounted() {
    const parsed = queryString.parse(location.search, { arrayFormat: 'bracket' })
    this.queryString = queryString.stringify(parsed, { arrayFormat: 'bracket' })
    this.setFilters(parsed)

    if (parsed.filters) {
      // this.filters = parsed.filters.map((v) => parseInt(v))
      this.filters = parsed.filters
    }

    $('#slider-range').slider({
      range: true,
      min: 0,
      max: 2500,
      values: parsed.price ? parsed.price.split(',') : [0, 2500],
      slide: (event, ui) => {
        $('#amount').val(ui.values[0] + ' Kč - ' + ui.values[1] + ' Kč')
        this.price = ui.values
        this.updateQuery()
      }
    })
    $('#amount').val(
      $('#slider-range').slider('values', 0) +
        ' Kč - ' +
        $('#slider-range').slider('values', 1) +
        ' Kč'
    )
  },
  methods: {
    ...mapActions({
      updateURL: 'filters/updateURL',
      setFilters: 'filters/setFilters'
    }),
    onFilter($event, value) {
      const checked = $event.target.checked

      if (checked) {
        this.filters.push(value.id.toString())
      } else {
        const index = this.filters.indexOf(value.id.toString())
        this.filters.splice(index, 1)
      }

      this.updateQuery()
    },
    updateQuery() {
      let data = {
        ...queryString.parse(location.search, { arrayFormat: 'bracket' }),
        filters: this.filters,
        page: 1
      }

      if (!_.isEmpty(this.price)) {
        data.price = this.price.join(',')
      }

      this.queryString = queryString.stringify(data, { arrayFormat: 'bracket' })
      this.updateURL(data)
    },
    isChecked(id) {
      return this.filters.indexOf(id.toString()) > -1
    },
    anyCheckedValues(label) {
      return label.values.filter((v) => this.isChecked(v.id)).length > 0
    }
  }
}
</script>
